import type { MapProvider } from '@gpx-spa/geo-domain';
import type { InjectionKey, Ref } from 'vue';

export const GPX_MAP_PROVIDER_KEY: InjectionKey<Ref<MapProvider> | MapProvider> =
  Symbol('gpxMapProvider');
